import React, { useEffect, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Home from '../pages/HomeComponent';
import Careers from '../pages/CareersComponent';
import Contact from '../pages/ContactComponent';
import CaseStudy1 from '../components/CaseStudy1Component';
import CaseStudy2 from '../components/CaseStudy2Component';
import CaseStudy3 from '../components/CaseStudy3Component';
import { fetchJobs } from '../redux/ActionCreators';
import Footer from '../components/Layout/FooterComponent';
import Mission from '../components/MissionComponent';
import Vision from '../components/VisionComponent';
import History from '../components/HistoryComponent';
import Examination from '../pages/Offerings/Examination';
import Consulting from '../pages/Offerings/Consulting';
import ItServices from '../pages/Offerings/ItService';
import { useLocation } from 'react-router-dom';
import CaseStudies from '../pages/CaseStudies';

const Main = () => {
    const [currentId, setCurrentId] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchJobs());
    }, [currentId, dispatch]);

    const location = useLocation();

    return (
        <>
            {/* <ScrollToTop /> */}
            <Switch location={location} key={location.key}>
                <Route exact path="/" component={() => <Home />} />
                {/* <Route path="/about" component={() => <About />} /> */}
                <Route path="/contact" component={() => <Contact />} />
                <Route path="/offerings/examination-as-a-service" component={() => <Examination />} />
                <Route path="/offerings/consulting" component={() => <Consulting />} />
                <Route path="/offerings/it-as-a-service" component={() => <ItServices />} />
                <Route path="/careers" component={() => <Careers
                    currentId={currentId}
                    setCurrentId={setCurrentId} />} />
                <Route path="/casestudy1" component={() => <CaseStudy1 />} />
                <Route path="/casestudy2" component={() => <CaseStudy2 />} />
                <Route path="/casestudy3" component={() => <CaseStudy3 />} />
                <Route path="/case-studies" component={() => <CaseStudies />} />
                {/* <Route path="/history" component={() => <History />} />
                <Route path="/vision" component={() => <Vision />} />
                <Route path="/mission" component={() => <Mission />} /> */}
                <Redirect to="/" />
            </Switch>
            <Footer />
        </>
    );
}

export default Main;